import type { FaireProductEntity } from "../../entity_types/product";

export const p_7yxayzh4gq: FaireProductEntity = {
  token: "p_7yxayzh4gq",
  type: "product",
  name: "Sun Ray - Fire Opal - Gold Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/276b00cb0d30eb04e47a713806ac2609179b93c7a8a53affc02cea15fb235dce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9b6adbc22d30adff89f0cb5ca5c9549dbc366c6769b42373241c6a9de668072.jpeg",
    "https://cdn.faire.com/fastly/83f92310fc8f4fa92b87262391d5301ac3252a1ad66210071fa93f2bbbdfebe7.jpeg",
    "https://cdn.faire.com/fastly/4fd583b2722fd2c731af54a563a3957522481683a42d21fdef539c46d74daa7c.jpeg",
    "https://cdn.faire.com/fastly/4f39bd6ab8f6899cd3abc67886ad53cb75baf3a37dac2764ce49f5b0cb13e1c9.jpeg",
    "https://cdn.faire.com/fastly/ae577a3ad1c753dfbbc5c790666b6373d63f359c9b4542c6afaf089401ec4e65.jpeg",
    "https://cdn.faire.com/fastly/4426071da363f6ae65a49804e5d041a20054263c080ab683370a03a403a76d38.jpeg",
    "https://cdn.faire.com/fastly/db3093abbb2dbdf151cef571f0e51dc9ac1393d15ec90c8c5683edf75245a5d1.jpeg",
  ],
  priceDollars: 18.2,
  description:
    "Radiate effortless boho charm with these gold sun ray stud earrings, featuring vibrant Fire Opal stones at the center for the perfect pop of color. Lightweight and easy to style, they bring a playful, free-spirited touch to any everyday look.\n\nSurgical-grade Stainless Steel Posts - 18K gold plating over brass\nTarnish-Free - Long-lasting protective coating that safeguards your jewelry\nHypoallergenic\nLab-grown Fire Opal Stone\nStone diameter:  3mm\nEarring length: 14mm\nButterfly back\nTop 10 Best-Selling Earrings",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:44.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
